'use strict'

const prodEnv = require('../../config/prod.env');
const coreWidgetVersion = prodEnv.HABITEO_WIDGETS_VERSION;

const offlineDependencies = {
    "cors": 
        {
            "BO": [
                `/js/hammer.min.js`,
                `/js/requestAnimationFrame-polyfill.js`,
                `/css/habiteo.widgets.css?v=1`
            ],
            "S3": [
                `/habiteo.widgets.min.js?v=${coreWidgetVersion}`,
                `/viewer.min.js?v=${coreWidgetVersion}`,
            ]
        }
    ,
    "no-cors": {}
};

export { offlineDependencies };


// WEBPACK FOOTER //
// ./src/private/offline-dependencies.js